export const CURRENT_SEMESTER = 'FA26';
export const ALL_SEMESTERS = ['SP20', 'FA20', 'SP21', 'FA21', 'SP22', 'FA22',
    'SP23', 'FA23', 'SP24', 'FA24', 'SP25', 'FA25', 'SP26', 'FA26']

export const MOBILE_BREAKPOINT = 920; // same as index.scss

export const START_DATE = '2026-08-24'
export const END_DATE = '2026-12-19'
export const MAX_EMAIL_LIMIT = 100;
export const MAX_BATCH_LIMIT = 49;

// These are the start date and launch date for QMI Wrap for the current semester
export const WRAPPED_START_DATE = "2026-11-22T00:00:00";
export const WRAPPED_LAUNCH_DATE = "2026-12-02T00:00:00";

/**
 * Maximum file size allowed for file uploads (in bytes).
 * Currently set to 30 MB.
 */
export const MAX_FILE_SIZE = 30 * 1024 * 1024; // 30 MB

/**
 * List of allowed file extensions for file uploads.
 * These extensions are case-insensitive when validated.
 */
export const ALLOWED_EXTENSIONS = ['jpg', 'jpeg', 'png', 'pdf', 'docx', 'ppt', 'pptx'];
